export function hasTruthyProperty(obj) {
  const values = Object.values(obj);

  return values.some(value => !!value);
}
